import { useMemo } from "react";
import "../../SalesReport/SalesReport.css";
import Logo1 from "../../../assets/images/logo1.png";
import Logo2 from "../../../assets/images/logo2.svg";
import { useSelector } from "react-redux";
import moment from "moment";

const SalesReturnReportHeader = () => {
  const { RAPrint } = useSelector((state) => state);
  const brand = useMemo(() => new URLSearchParams(window.location.search).get("brand"), []);
  const _logo = brand === "DL1961" ? Logo1 : Logo2;
  const headerData = RAPrint && RAPrint?.payload?.data[0];

  return (
    <div className="__header">
      <table width="100%">
        <tbody>
          <tr>
            <td width="65%" style={{ paddingRight: "5px" }}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <div className="__image_container">
                                <img width={250} height={72} src={_logo} alt="Brand Logo" />
                              </div>
                            </td>
                            <td valign="top" width="100%">
                              <div className="__addr">
                                <p>DLPD CANADA LTD.</p>
                                <p>15 Wertheim Court, Suite 409,</p>
                                <p>Richmond Hill, ON L4B 3H7 , Canada</p>
                                <p>Business # : 763395530RT0001</p>
                                <p>Email : orderca@dl1961.com</p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <table className="__addr_table" width="50%">
                        <tbody>
                          <tr>
                            <td valign="top">Name :</td>
                            <td colSpan={3}>{headerData && headerData.bill_to_customer}</td>
                          </tr>
                          <tr>
                            <td valign="top">Address :</td>
                            <td colSpan={3}>
                              {headerData && headerData?.bill_to_address_1} { }
                              {headerData?.bill_to_address_2 && headerData?.bill_to_address_2}
                              {/* <div> */}
                              {headerData && ` ${headerData?.bill_to_city_name}, ${headerData?.bill_to_state_name}, ${headerData?.bill_to_country}, ${headerData?.bill_to_zip}`}
                            </td>
                          </tr>
                          <tr>
                            <td valign="top">Email :</td>
                            <td colSpan={3}>{headerData?.email || ''}</td>
                          </tr>
                          <tr>
                            <td valign="top">Tel No :</td>
                            <td>{headerData?.phone || ''}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td valign="top" width="35%" style={{ paddingLeft: "5px" }}>
              <table width="100%" className="__box">
                <tbody>
                  <tr>
                    <td colSpan={2} className="__heading" align="center">Sales Return
                    </td>
                  </tr>
                  <tr>
                    <td width="40%" valign="top">Ref # :</td>
                    <td>
                      {headerData && headerData.ra_no}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">RA Approval Date :</td>
                    <td>
                      {headerData && moment(headerData.ra_approval_date).format("MM-DD-YYYY")}
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">Invoice # :</td>
                    <td>
                      {headerData?.invoice_header_no}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SalesReturnReportHeader;
